/**
 * Normalize personnel jurisdiction / employment / office → "CO" | "US".
 * Prefer explicit jurisdiction; fall back to employment type, then office location.
 */
export function normalizeLeaveJurisdiction(
  jurisdiction,
  employmentType,
  officeLocation
) {
  const j = String(jurisdiction || "")
    .trim()
    .toUpperCase();
  if (j === "CO" || j === "COL" || j === "COLOMBIA") return "CO";
  if (j === "US" || j === "USA" || j === "UNITED STATES") return "US";

  const emp = String(employmentType || "").toLowerCase();
  if (
    emp.includes("colombia") ||
    emp.includes("colombian") ||
    emp === "colombian_labor_contract" ||
    emp === "col_emp"
  ) {
    return "CO";
  }
  if (emp.includes("w2") || emp.includes("w-2") || emp === "us_w2") {
    return "US";
  }

  const office = String(officeLocation || "").toLowerCase();
  if (
    office.includes("colombia") ||
    office.includes("bogotá") ||
    office.includes("bogota") ||
    office.includes("medellín") ||
    office.includes("medellin")
  ) {
    return "CO";
  }
  if (
    office.includes("united states") ||
    office.includes(" u.s") ||
    /\busa?\b/.test(office) ||
    office.includes("texas") ||
    office.includes("austin") ||
    office.includes("remote-us")
  ) {
    return "US";
  }

  return "US";
}
